import { render, staticRenderFns } from "./TeamTrainersList.vue?vue&type=template&id=38465f0f&scoped=true&"
import script from "./TeamTrainersList.vue?vue&type=script&lang=js&"
export * from "./TeamTrainersList.vue?vue&type=script&lang=js&"
import style0 from "./TeamTrainersList.vue?vue&type=style&index=0&id=38465f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38465f0f",
  null
  
)

export default component.exports